import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import { postLogin } from '../../Core/User/Login/action';
import styles from "../../Assets/Styles/Components/login/Login.module.css";
import Loader from "../Loader";
import Logo from '../../Assets/Images/logo.png';

class Login extends Component {
	constructor() {
		super();
		this.state = {
			isTrueNum: true
		};
	}

	componentDidUpdate(preProps) {
		if (this.props.phone.length === 11 && preProps.login && this.props.login && !this.props.login.loading && this.props.login.login.message) {
			this.props.onLogin();
		}
	}

	onLogin = () => {
		this.getMobiles(this.props.phone);
		const res = this.getMobiles(this.props.phone);
		if (res === true) {
			this.setState({ isTrueNum: true });
			const search = Object.fromEntries(new URLSearchParams(window.location.search.substring(1)));
			const body = {};
			if (search.utm_source) {
				body.utm_source = search.utm_source;
			}
			if (search.utm_medium) {
				body.utm_medium = search.utm_medium;
			}
			if (search.utm_term) {
				body.utm_term = search.utm_term;
			}
			if (search.utm_content) {
				body.utm_content = search.utm_content;
			}
			if (search.utm_campaign) {
				body.utm_campaign = search.utm_campaign;
			}
			const queries = new URLSearchParams(body).toString();
			this.props.postLogin(this.props.phone, queries);
		} else {
			this.setState({ isTrueNum: false });
		}
	}

	onChange = (event) => {
		const { value } = event.currentTarget;
		this.setState({ isTrueNum: true });
		this.props.onChange(this.toEnglishDigits(value));
	}

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			this.props.postLogin(this.props.phone);
		}
	}

	toEnglishDigits = (str) => {
		// convert persian digits [۰۱۲۳۴۵۶۷۸۹]
		let e = '۰'.charCodeAt(0);
		str = str.replace(/[۰-۹]/g, (t) => {
			return t.charCodeAt(0) - e;
		});
		// convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
		e = '٠'.charCodeAt(0);
		str = str.replace(/[٠-٩]/g, (t) => {
			return t.charCodeAt(0) - e;
		});
		return str.replace(/[^0-9]/g, '');
	}

	getMobiles = (str) => {
		const numreg = /^09[0|1|2|3|9][0-9]{8}$/g;
		return numreg.test(str);
	};

	render() {
		const { phone, onLogin, login } = this.props;
		const { isTrueNum } = this.state;
		// console.log("LOGIN : ",);
		return (
			<div className={styles.loginBox}>
				<>
					<div className={styles.imgContainer}>
						<img src={Logo} alt="logo" />
					</div>
					<h3 className={styles.loginText}>ورود / ثبت‌نام</h3>
					<p className={`${styles.titleText} text-muted`}>شماره موبایل خود را وارد کنید:</p>
					<input
						type="text"
						placeholder="شماره موبایل"
						className={`${styles.numberInput} text-center`}
						autoFocus
						onChange={this.onChange}
						value={phone}
						onKeyPress={this.handleKeyPress}
						data-parsley-pattern="(0|\+98)?([ ]|,|-|[()]){0,2}9[0|1|2|3|4|9]([ ]|,|-|[()]){0,2}(?:[0-9]([ ]|,|-|[()]){0,2}){8}"
					/>
					{
						phone !== "" && login && login.login && login.login.error && <div className={styles.error}>{login.login.error[0]}</div>
					}
					{
						isTrueNum === false && <div className={styles.error}>لطفا شماره خود را بصورت صحیح وارد کنید!</div>
					}
					{this.props.login.loading ? <Loader /> : <div className={`${styles.btnLogin} btn-block btn-primary`} onClick={this.onLogin}>ادامه</div>}
				</>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		login: state.login,
	};
};
export default connect(mapStateToProps, { postLogin })(Login);
